import React, {useDebugValue} from 'react';

import classNames from 'classnames';

import {ButtonIcon as ButtonIconDefault, ButtonIconPrimary} from '@homeaway/react-buttons';

// ButtonIconDefault.whyDidYouRender = true;
// ButtonIconPrimary.whyDidYouRender = true;

import {useSearchFormContext} from '../../../hooks/useSearchFormContext';
import {useTrackingContext} from '../../../hooks/useTrackingContext';

import {triggerSubmitSummaryClickEdapEvent} from '../../../utils/edap';
import {hasCheckAvailabilitySubmitActionType, showSubmitPrimaryAction} from '../../../utils/submit';

import {SearchIcon} from '../../SearchIcon/SearchIcon';

const classNamespace = 'search-form';
const fieldClassName = `${classNamespace}__field`;
const buttonFieldClassName = `${classNamespace}__button-field`;
const summaryFieldClassName = `${classNamespace}__summary-field`;
const summaryButtonFieldClassName = `${classNamespace}__summary-button-field`;
const submitSummaryButtonFieldClassName = `${classNamespace}__submit-summary-button-field`;

function useComponent() {
    const {
        edapOptions,
        formSettings: {
            hasLoaded,
            isSubmitting
        },
        submitEvents: {
            onClick: onSubmitClick
        },
        submitOptions,
        submitOptions: {
            iconName
        },
        translations: {
            checkAvailabilityLabelText,
            searchLabelText
        },
        submitSummaryEvents: {
            onClick: onSubmitSummaryClick
        }
    } = useSearchFormContext();

    const trackingContext = useTrackingContext();

    const className = classNames(fieldClassName, buttonFieldClassName, summaryFieldClassName, summaryButtonFieldClassName, submitSummaryButtonFieldClassName);

    const ButtonIcon = (
        showSubmitPrimaryAction(submitOptions)
            ? ButtonIconPrimary
            : ButtonIconDefault
    );

    const type = 'submit';

    const labelIcon = (
        <SearchIcon name={iconName}/>
    );

    const labelText = (
        hasCheckAvailabilitySubmitActionType(submitOptions)
            ? checkAvailabilityLabelText
            : searchLabelText
    );

    const label = (
        <>
            {labelIcon}
            <span className="sr-only">{labelText}</span>
        </>
    );

    const srOnlyLabel = false;

    const disabled = !hasLoaded || isSubmitting;
    const loading = hasLoaded && isSubmitting;

    function handleClick(...args) {
        triggerSubmitSummaryClickEdapEvent(trackingContext, edapOptions);

        onSubmitClick(...args);
        onSubmitSummaryClick(...args);
    }

    const result = {
        className,
        ButtonIcon,
        type,
        label,
        srOnlyLabel,
        disabled,
        loading,
        onClick: handleClick
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
